module.exports = __webpack_public_path__ + "img/plasvale.a0b96027.svg";